export var method = function method(controller, methodName) {
  var method = controller[methodName];

  if (typeof method == 'function') {
    return method;
  }

  throw new Error("undefined method \"".concat(methodName, "\""));
};
export var composeEventName = function composeEventName(name, controller, eventPrefix) {
  var composedName = name;

  if (eventPrefix === true) {
    composedName = "".concat(controller.identifier, ":").concat(name);
  } else if (typeof eventPrefix === 'string') {
    composedName = "".concat(eventPrefix, ":").concat(name);
  }

  return composedName;
};
export var extendedEvent = function extendedEvent(type, event, detail) {
  var _ref = event || {
    bubbles: true,
    cancelable: true,
    composed: true
  },
      bubbles = _ref.bubbles,
      cancelable = _ref.cancelable,
      composed = _ref.composed;

  if (event) {
    Object.assign(detail, {
      originalEvent: event
    });
  }

  var customEvent = new CustomEvent(type, {
    bubbles: bubbles,
    cancelable: cancelable,
    composed: composed,
    detail: detail
  });
  return customEvent;
};
export var isElementInViewport = function isElementInViewport(el) {
  var rect = el.getBoundingClientRect();
  return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
};